export default "__VITE_ASSET__CEQTpT6q__"